export const AGE_RECIPIENT_PREFIX = "age1";
export const AGE_SECRET_KEY_PREFIX = "AGE-SECRET-KEY-";

export const utf8Encoder = new TextEncoder();
export const utf8Decoder = new TextDecoder("utf-8", { fatal: true });
